import { createFileRoute } from '@tanstack/react-router';
import LandingPage from '../pages/LandingPage';

// Public landing page at "/". Authenticated users see a "Go to app" link.
export const Route = createFileRoute('/')({
  component: LandingPage
});
